export const EmployeeSupportUrl = "https://www.get-carrot.com/employee-support"
